import { lazy, Suspense } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import LoadingScreen from "../../../components/LoadingScreen.js";
import HeaderWithRole from "src/components/header/HeaderWithRole.js";
import AuthGuard from "src/guards/AuthGuard.js";

const Loadable = (Component) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pathname } = useLocation();
  const isDashboard = pathname.includes("/dashboard");

  return (
    <Suspense
      fallback={
        <LoadingScreen
          sx={{
            ...(!isDashboard && {
              top: 0,
              left: 0,
              width: 1,
              zIndex: 9999,
              position: "fixed",
            }),
          }}
        />
      }
    >
      <Component {...props} />
    </Suspense>
  );
};

// component

const Resultoneway = Loadable(
  lazy(() => import("src/pages/dashboard/resultoneway"))
);

const Resulttwoway = Loadable(
  lazy(() => import("src/pages/dashboard/resulttwoway.js"))
);

const Travellersinfo = Loadable(
  lazy(() => import("src/pages/dashboard/TravellersInfo"))
);
const TwoWayTravellersInfo = Loadable(
  lazy(() => import("src/pages/dashboard/TwoWayTravellersInfo"))
);
const CreateBooking = Loadable(lazy(() => import("src/pages/BookingApi")));
const NewEngine = Loadable(lazy(() => import("src/components/_dashboard/general-app/FlightEngine/NewEngine.js")));

export const FlightRoutes = () => ({
  path: "Flight",
  element: (
    <>
      <AuthGuard>
        <div className="bg-white">
          <HeaderWithRole />
        </div>
        <Outlet />
      </AuthGuard>
    </>
  ),
  children: [
    {
      path: "",
      element: <Navigate to="/Flight" replace />,
    },
    {
      path: "resulttwoway",
      element: <Resulttwoway />,
    },
    { path: "resultoneway", element: <Resultoneway /> },
    { path: "travellersinfo", element: <Travellersinfo /> },
    { path: "twotravellerinfo", element: <TwoWayTravellersInfo /> },
    // { path: "test", element: <NewEngine /> },
    { path: "createBooking", element: <CreateBooking /> },
  ],
});


